import { ViewStream, safeClone, SpyneAppProperties } from 'spyne';
import { PageDeckTraits } from 'traits/deck/page-deck-traits.js';
import PageTmpl from './templates/page.tmpl.html';

export class PageDeckView extends ViewStream {
  constructor(props = {}) {
    props.class = `page-view page-view-${props?.data?.pageId}`;
    props.channels = [['CHANNEL_ROUTE', true]];
    props.traits = [PageDeckTraits];
    props.data = safeClone(props.data);
    props.data.href = SpyneAppProperties.getHrefFromData(props.data);
    props.template = PageTmpl;

    super(props);
  }
  addActionListeners() {
    return [['CHANNEL_ROUTE_CHANGE_EVENT', 'disposeViewStream']];
  }

  broadcastEvents() {
    return [['a', 'click']];
  }

  onRendered() {
    this.pageDeck$onRendered();
  }
}
